import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from "./router";


Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        accessToken: null,
        loggingIn: false,
        loginError: null
    },
    mutations: {
        loginStart: state => (state.loggingIn = true),
        loginStop: (state, errorMessage) => {
            state.loggingIn = false;
            state.loginError = errorMessage;
        },
        updateAccessToken: (state, accessToken) => {
            state.accessToken = accessToken;
        },
        logout: state => {
            state.accessToken = null;
        }
    },
    actions: {
        doLogin({ commit }, loginData) {
            commit("loginStart");
            return axios
                .post("apidev/users/login/", {
                    ...loginData
                })
                .then(response => {
                    localStorage.setItem("accessToken", response.data.token);
                    commit("loginStop", null);
                    commit("updateAccessToken", response.data.token);

                    axios
                        .post(
                            "apidev/users/info", {
                                type: "monitor",
                                email: loginData.email
                            }, {
                                headers: {
                                    "x-access-token": response.data.token
                                }
                            }
                        )
                        .then(response => {
                            localStorage.setItem("name", response.data.nombre + " " + response.data.apellido);
                            localStorage.setItem("first_name", response.data.nombre);
                            localStorage.setItem("last_name", response.data.apellido);
                            localStorage.setItem("category", window.btoa(response.data.name_category));
                            if (response.data.profile_image) {
                                localStorage.setItem("profile_image", "apidev/" + response.data.profile_image);
                            } else {
                                localStorage.setItem("profile_image", "");
                            }
                            localStorage.setItem("email", response.data.email);
                            localStorage.setItem("user_id", response.data.user_id);

                            if (router.history.current.query.next) {
                              router.push(router.history.current.query.next);
                            } else {
                              router.push("/explorer");
                            }
                        })
                        .catch(error => {
                            commit("loginStop", error.response.data.error);
                            commit("updateAccessToken", null);
                        });
                })
                .catch(error => {
                    commit("loginStop", error.response.data.message);
                    commit("updateAccessToken", null);
                    return Promise.reject(error.response.data.message);
                });
        },
        fetchAccessToken({ commit }) {
            commit("updateAccessToken", localStorage.getItem("accessToken"));
        },
        logout({ commit }) {
            localStorage.clear()
            // localStorage.removeItem("accessToken");
            // localStorage.removeItem("name");
            // localStorage.removeItem("category");
            // localStorage.removeItem("first_name");
            // localStorage.removeItem("last_name");
            // localStorage.removeItem("profile_image");
            // localStorage.removeItem("email");
            // localStorage.removeItem("user_id");
            commit("logout");
            router.push("/login");
        }
    }
});

export default store;